import DashboardStats from './DashboardStats'
import PrivateFilesCard from './PrivateFilesCard'
import MainLayout from '../../components/Layout'
import { useUserContext } from '../../context/UserContext'
import './style.css'

function AdminDashboard() {
  // Private viewers only see the folders shared with them — no sales analytics.
  const { isPrivateViewer } = useUserContext()

  return (
    <MainLayout>
      {!isPrivateViewer && <DashboardStats />}
      <PrivateFilesCard />
    </MainLayout>
  )
}

export default AdminDashboard
